import { GridCellParams } from '@mui/x-data-grid-pro';
import { Link } from 'react-router-dom';
import { GridCustomColDef } from '../../../types';
import {
  advancedOperators,
  advancedDatePickerOperator,
  advancedNumericOperators
} from '../../../Compounds/UpstackDataGrid/helpers';
import { getFormattedDate } from '../../../../utils/helpers';

export const DefaultLinkEventGridColumnDefs: GridCustomColDef[] = [
  {
    field: 'linkAction.createdAt',
    headerName: 'Event Date',
    sortable: true,
    valueGetter: (_value, row) => {
      return row?.linkAction?.createdAt ? new Date(row?.linkAction?.createdAt) : '';
    },
    valueFormatter: (value) => {
      return getFormattedDate(value, 'lll');
    },
    type: 'singleSelect',
    filterable: true,
    flex: 1,
    description: 'Drag to move column',
    filterOperators: advancedDatePickerOperator()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'sfdcUpstackId',
    headerName: 'Asset UPSTACK ID',
    renderCell: (params: GridCellParams) => (
      <Link
        className="text-indigo"
        title="Fullscreen"
        to={`/asset/${params.value}`}>
        <div className="flex items-center text-small">{params.value as string}</div>
      </Link>
    ),
    sortable: true,
    filterable: true,
    flex: 1,
    description: 'Drag to move column',
    filterOperators: advancedOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'rpmAccountId',
    headerName: 'RPM Account ID',
    renderCell: (params: GridCellParams) => (
      <Link
        className="text-indigo"
        title="Fullscreen"
        to={`/rpm-account/${params.value}`}>
        <div className="flex items-center text-small">{(params.value as string) ?? ''}</div>
      </Link>
    ),
    sortable: true,
    filterable: true,
    flex: 1,
    description: 'Drag to move column',
    filterOperators: advancedNumericOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'content',
    headerName: 'Content',
    filterable: false,
    sortable: true,
    flex: 1,
    valueGetter: (_value, row) => row?.content?.message,
    description: 'Drag to move column',
    filterOperators: advancedOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'linkAction.origin',
    headerName: 'Origin',
    sortable: true,
    filterable: true,
    flex: 1,
    valueGetter: (_value, row) => row?.linkAction?.origin,
    description: 'Drag to move column',
    filterOperators: advancedOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'linkAction.operation',
    headerName: 'Operation',
    sortable: true,
    filterable: true,
    flex: 1,
    valueGetter: (_value, row) => row?.linkAction?.operation,
    description: 'Drag to move column',
    filterOperators: advancedOperators()
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'linkAction.createdBy.email',
    headerName: 'User',
    sortable: true,
    filterable: true,
    flex: 1,
    description: 'Drag to move column',
    valueGetter: (_value, row) => row?.linkAction?.createdBy?.email,
    filterOperators: advancedOperators(),
    hideByDefault: false
  },
  {
    type: 'singleSelect',
    valueOptions: [],
    field: 'id',
    headerName: 'Log ID',
    sortable: true,
    filterable: true,
    flex: 1,
    description: 'Drag to move column',
    filterOperators: advancedOperators(),
    hideByDefault: true
  }
];
